var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent pl-1" }, [
    _c("article", { staticClass: "tile is-child box" }, [
      _c(
        "div",
        { staticStyle: { "max-height": "500px", "overflow-y": "auto" } },
        [
          _c(
            "table",
            {
              staticClass: "table is-bordered is-fullwidth sticky-header-table",
            },
            [
              _vm._m(0),
              _c(
                "tbody",
                [
                  _vm._l(_vm.parentPermissions, function (parent) {
                    return [
                      _vm._l(_vm.renderRows(parent, 0), function (row) {
                        return [
                          _c("PermissionRow", {
                            key: row.permission.permissionRecordID,
                            attrs: {
                              permission: row.permission,
                              "all-permissions": _vm.value.userAccessControl,
                              level: row.level,
                            },
                            on: { toggle: _vm.handleToggle },
                          }),
                        ]
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "220px" } }),
        _c("th", { staticStyle: { width: "60px" } }, [_vm._v("Block")]),
        _c("th", { staticStyle: { width: "60px" } }, [_vm._v("View")]),
        _c("th", { staticStyle: { width: "60px" } }, [_vm._v("Add")]),
        _c("th", { staticStyle: { width: "60px" } }, [_vm._v("Edit")]),
        _c("th", { staticStyle: { width: "60px" } }, [_vm._v("Delete")]),
        _c("th", { staticStyle: { width: "60px" } }, [_vm._v("Print")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }